import React from "react"

export const TrashIcon = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.5584 4.35833C16.2167 4.225 14.875 4.125 13.525 4.05V4.04167L13.3417 2.95833C13.2167 2.19167 13.0334 1.04167 11.0834 1.04167H8.90005C6.95838 1.04167 6.77505 2.14167 6.64172 2.95L6.46672 4.01667C5.69172 4.06667 4.91672 4.11667 4.14172 4.19167L2.44172 4.35833C2.09172 4.39167 1.84172 4.7 1.87505 5.04167C1.90838 5.38333 2.20838 5.63333 2.55838 5.6L4.25838 5.43333C8.62505 5 13.0251 5.16667 17.4417 5.60833C17.4667 5.60833 17.4834 5.60833 17.5084 5.60833C17.8251 5.60833 18.1 5.36667 18.1334 5.04167C18.1584 4.7 17.9084 4.39167 17.5584 4.35833Z"
        fill="#FF0000"
      />
      <path
        d="M16.0254 6.78333C15.8254 6.575 15.5504 6.45833 15.2671 6.45833H4.73378C4.45044 6.45833 4.16711 6.575 3.97544 6.78333C3.78378 6.99167 3.67544 7.275 3.69211 7.56667L4.20878 16.1167C4.30044 17.3833 4.41711 18.9667 7.32544 18.9667H12.6754C15.5838 18.9667 15.7004 17.3917 15.7921 16.1167L16.3088 7.575C16.3254 7.275 16.2171 6.99167 16.0254 6.78333ZM11.3838 14.7917H8.60878C8.26711 14.7917 7.98378 14.5083 7.98378 14.1667C7.98378 13.825 8.26711 13.5417 8.60878 13.5417H11.3838C11.7254 13.5417 12.0088 13.825 12.0088 14.1667C12.0088 14.5083 11.7254 14.7917 11.3838 14.7917ZM12.0838 11.4583H7.91711C7.57544 11.4583 7.29211 11.175 7.29211 10.8333C7.29211 10.4917 7.57544 10.2083 7.91711 10.2083H12.0838C12.4254 10.2083 12.7088 10.4917 12.7088 10.8333C12.7088 11.175 12.4254 11.4583 12.0838 11.4583Z"
        fill="#FF0000"
      />
    </svg>
  )
}
